// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton-module__skeleton","shimmerMobile":"Skeleton-module__shimmerMobile","shimmerDesktop":"Skeleton-module__shimmerDesktop"};